export default {"src":"/_next/static/image/public/img/New_VF_Icon_RGB_RED.7b97b071c41dce3e912825937b7565fb.svg","height":416,"width":416};